import { supabaseClient } from '@auth-v2';
import { useQuery } from '@tanstack/react-query';

import { getSwingMeasuredParameters } from '@data';

function getSwingMeasuredParametersKey(): string[] {
    return ['swingMeasuredParameters'];
}

export const useSwingMeasuredParameters = () => {
    return useQuery({
        queryKey: getSwingMeasuredParametersKey(),
        queryFn: async () => {
            const data = await getSwingMeasuredParameters(supabaseClient);
            return data;
        },
        retry: 3,
    });
};
